import type { GamePlayerProjectionTrading } from '@library/types/trading';
import { TradingProjection } from '@bo-components/trading/projections';
import { findProjectionByProjectionId } from '@bo-utils/projection';

export interface TradingProjectionsProps {
  changes: Array<Partial<GamePlayerProjectionTrading>>;
  playerId: string;
  projections: Array<GamePlayerProjectionTrading>;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: Partial<GamePlayerProjectionTrading>;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}

export const TradingProjections = ({
  changes,
  playerId,
  projections,
  updateProjection
}: TradingProjectionsProps) => {
  return (
    <div className="flex flex-auto items-center overflow-y-hidden [overflow-x:overlay] [scrollbar-gutter:stable]">
      {projections?.map((projection) => {
        const { projectionId } = projection;
        const change = findProjectionByProjectionId({
          projectionArray: changes,
          projectionId
        });

        return (
          <TradingProjection
            change={change}
            key={`projection-${projectionId}`}
            playerId={playerId}
            projection={projection}
            updateProjection={updateProjection}
          />
        );
      })}
    </div>
  );
};
